<fut-base-dialog [hideClose]="true">
  <div class="d-flex flex-column">
    @if (lottiePath(); as lottiePath) {
      <div class="d-flex justify-content-center lottie-container">
        <ng-lottie [options]="{ path: lottiePath, loop: false }"></ng-lottie>
      </div>
    }
    <div class="d-flex flex-column fut-gap-16">
      @if (infoTitle(); as infoTitle) {
        <h1 class="fut-h1 text-center">
          {{ infoTitle | transloco }}
        </h1>
      }
      @if (infoSubTitle(); as infoSubTitle) {
        <p class="fut-text-light text-center">
          {{ infoSubTitle | transloco }}
        </p>
      }
    </div>
  </div>
</fut-base-dialog>
